<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="name">Name</label>
          <InputText v-model="name" id="name"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="relationship">Relationship</label>
          <InputText id="relationship" v-model="relationship"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="homeTelephone">Home Telephone</label>
          <InputText id="homeTelephone" v-model="homeTelephone"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="mobile">Mobile</label>
          <InputText id="mobile" v-model="mobileNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="workTelephone">Work Telephone</label>
          <InputText id="workTelephone" v-model="workTelephone"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'emergencyContact',
  data() {
    return {
      name: '',
      relationship: '',
      stateNumber: '',
      city: '',
      zipNumber: '',
      country: '',
      homeTelephone: '',
      mobileNumber: '',
      workTelephone: '',
      filters: {},
      loading: false,
      editing: false,
      holidayId: null
    }
  },
  methods: {
    async addHoliday() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let holiday = {
        id: this.holidayId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', holiday)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', holiday)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
    },
    cancel() {
    }
  },
  components: {
    Button,
    InputText,
    Dropdown
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// emergencyContact.vue?5ef134ed